import DatatableFooter from "./datatable-footer.container";

export default DatatableFooter;
